<div
  #previewContainer
  class="picture-hover-preview"
  [style.left.px]="x"
  [style.top.px]="y"
  >
  <!-- Image container with slideshow -->
  <div class="image-container" [style.--blur-src]="currentImageUrl ? 'url(' + currentImageUrl + ')' : 'none'">
    <!-- Loading placeholder -->
    @if (!currentImageUrl) {
      <div class="image-placeholder">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M4 16L8.586 11.414C9.367 10.633 10.633 10.633 11.414 11.414L16 16M14 14L15.586 12.414C16.367 11.633 17.633 11.633 18.414 12.414L20 14M14 8H14.01M6 20H18C19.105 20 20 19.105 20 18V6C20 4.895 19.105 4 18 4H6C4.895 4 4 4.895 4 6V18C4 19.105 4.895 20 6 20Z" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    }

    <!-- Actual image -->
    @if (currentImageUrl && !imageError) {
      <img
        [src]="currentImageUrl"
        alt="Picture preview"
        class="preview-image"
        (error)="onImageError()"
        />
    }

    <!-- Error placeholder (shown when image fails to load) -->
    @if (imageError) {
      <div class="image-placeholder error">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M4 16L8.586 11.414C9.367 10.633 10.633 10.633 11.414 11.414L16 16M14 14L15.586 12.414C16.367 11.633 17.633 11.633 18.414 12.414L20 14M14 8H14.01M6 20H18C19.105 20 20 19.105 20 18V6C20 4.895 19.105 4 18 4H6C4.895 4 4 4.895 4 6V18C4 19.105 4.895 20 6 20Z" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    }

    <!-- Picture counter badge (only for multiple pictures) -->
    @if (hasMultiplePictures) {
      <div class="counter-badge">
        {{ currentIndex + 1 }} / {{ pictures.length }}
      </div>
    }
  </div>

  <!-- Picture info -->
  @if (currentPicture) {
    <div class="info-section">
      <!-- Date -->
      @if (currentPicture.created_at) {
        <div class="info-row">
          <svg class="info-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.105 21 21 20.105 21 19V7C21 5.895 20.105 5 19 5H5C3.895 5 3 5.895 3 7V19C3 20.105 3.895 21 5 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="info-text">{{ getFormattedDate(currentPicture.created_at) }}</span>
        </div>
      }
      <!-- Direction -->
      @if (currentPicture.direction != null) {
        <div class="info-row">
          <svg class="info-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L19 21L12 17L5 21L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="info-text">{{ getDirectionText(currentPicture.direction) }}</span>
        </div>
      }
      <!-- Site name -->
      @if (currentPicture.siteName) {
        <div class="info-row site-name">
          <svg class="info-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M17.657 16.657L13.414 20.9C12.633 21.681 11.367 21.681 10.586 20.9L6.343 16.657C3.219 13.533 3.219 8.467 6.343 5.343C9.467 2.219 14.533 2.219 17.657 5.343C20.781 8.467 20.781 13.533 17.657 16.657Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 11C12.552 11 13 10.552 13 10C13 9.448 12.552 9 12 9C11.448 9 11 9.448 11 10C11 10.552 11.448 11 12 11Z" fill="currentColor"/>
          </svg>
          <span class="info-text truncate">{{ currentPicture.siteName }}</span>
        </div>
      }
    </div>
  }

  <!-- Slide indicators (dots) for small sets of pictures -->
  @if (showDots) {
    <div class="slide-indicators">
      @for (pic of pictures; track pic; let i = $index) {
        <span
          class="indicator-dot"
          [class.active]="i === currentIndex"
        ></span>
      }
    </div>
  }

  <!-- Counter indicator for large sets of pictures -->
  @if (showCounter) {
    <div class="slide-counter">
      {{ currentIndex + 1 }} / {{ pictures.length }}
    </div>
  }
</div>
